<template>
  <div class="card-image-upload">
    <image-upload
      v-model="card.image"
      name="front-image"
      :label="allowBackImage ? 'Front image' : 'Card image'"
      :icon="allowBackImage ? 'camera_front' : 'upload_file'"
      width="150"
      height="250"
      @result="$emit('result', $event)"
    />

    <image-upload
      v-if="allowBackImage"
      v-model="card.imageBack"
      name="back-image"
      label="Back image"
      icon="camera_rear"
      width="150"
      height="250"
      @result="$emit('result', $event)"
    />
  </div>
</template>

<script>
export default {
  props: {
    value: Object,
    allowBackImage: Boolean,
  },

  data() {
    return {
      card: this.value,
    };
  },

  watch: {
    card: {
      handler(value) {
        this.$emit('input', value);
      },
      deep: true,
    },

    value(value) {
      this.card = value;
    },
  },
};
</script>

<style lang="scss" scoped>
.card-image-upload {
  position: relative;
  display: flex;

  > * {
    flex: 1;

    &:not(:last-child) {
      margin-right: $gp;
    }
  }
}

.button-container {
  position: absolute;
  bottom: 0;
  right: $gp * .5;
}
</style>
